export enum FilterOfficeEnterpriseEnum {
  my_office = 'my_office',
  my_enterprise = 'my_enterprise',
}

export const FilterOfficeEnterpriseLabels = {
  [FilterOfficeEnterpriseEnum.my_office]: 'My Office',
  [FilterOfficeEnterpriseEnum.my_enterprise]: 'My Enterprise',
};

export const FilterOfficeEnterpriseItems = [
  {
    text: FilterOfficeEnterpriseLabels[FilterOfficeEnterpriseEnum.my_office],
    value: FilterOfficeEnterpriseEnum.my_office,
  },
  {
    text: FilterOfficeEnterpriseLabels[FilterOfficeEnterpriseEnum.my_enterprise],
    value: FilterOfficeEnterpriseEnum.my_enterprise,
  },
];
